import { getRegexFromString, normalizePath } from '../../../utilities/path';

export function isExitLink(href: string, excludeExitLinks: string[]) {
    const hostname = document.location.hostname.toLowerCase();
    const targetHost = new URL(href).hostname.toLowerCase();
    const isLinkWhitelisted = excludeExitLinks.find(excludeExitLink => {
        const excludeLinkRegex = getRegexFromString(excludeExitLink);
        return Boolean(href.match(excludeLinkRegex));
    });
    return hostname !== targetHost && !(targetHost.match(/\.macu\.com$/) || isLinkWhitelisted || href.match(/^tel:/) || href.match(/^mailto:/));
}

/**
 * Returns boolean that indicates if LPL disclaimer should be shown and redirect interrupted
 * @param href: string
 * @param paths: string[]
 */
export function isLPLDisclaimerRequired(href: string, paths: string[]) {
    
    const originPathname = normalizePath(document.location.pathname);
    const targetPathname = normalizePath(new URL(href).pathname);
    let isOriginLPL = false;
    let isTargetLPL = false;
    for (const path of paths) {
        const pathRegex = getRegexFromString(path);
        isOriginLPL = isOriginLPL || Boolean(originPathname.match(pathRegex));
        isTargetLPL = isTargetLPL|| Boolean(targetPathname.match(pathRegex));
    }
    return !isOriginLPL && isTargetLPL;
}